<template>
  <div class="page-contacts-distributors">
    <div class="page-contacts-distributors__column --first">
      <ul class="page-contacts-distributors__nav m-bot-5">
        <li v-for="region in regions" :key="region">
          <NuxtLink
            class="text-l"
            :to="
              localePath({
                name: 'contacts-distributors-region',
                params: {
                  region: $t(`filters.${region}`).toLowerCase(),
                },
              })
            "
            >{{ $t(`filters.${region}`) }}
          </NuxtLink>
        </li>
      </ul>
    </div>
    <div class="page-contacts-distributors__column --last">
      <div class="page-contacts-distributors__map">
        <LocatorMap
          @location-select="onSelect"
          :locations="props.distributors"
          :options="mapOptions"
        />
      </div>

      <ul
        class="page-contacts-distributors__locations m-top-5"
        v-if="props.distributors.length"
      >
        <li
          v-for="location in props.distributors"
          :key="location.id"
          :id="location.id"
        >
          <LocatorLocation
            :location="location"
            :selected="location.id === selectedId"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagesContactsDistributors',
}
</script>

<script setup>
const props = defineProps({
  distributors: Object,
})

const regions = ['italia', 'europa', 'mondo']

const mapOptions = {
  maxZoom: 14,
  minZoom: 2,
}

const selectedId = ref(null)

const onSelect = (id) => {
  selectedId.value = id
}
</script>

<style lang="scss">
@import './style.scss';
</style>
